import { Component, computed, input } from '@angular/core';

import { IHeaderParams, SortDirection } from 'ag-grid-community';

import { FontIconComponent } from '@camelot/icons';

import { GridContext } from '../../models/grid-data';
import { FilterModelSource } from '../../models/types';

@Component({
  imports: [FontIconComponent],
  selector: 'cam-ag-grid-base-header',
  styleUrl: './base-header.component.scss',
  templateUrl: './base-header.component.html',
})
export class BaseHeaderComponent {
  params = input.required<IHeaderParams<unknown, GridContext>>();

  public readonly filterEnabled = computed(() => !!this.params().column.getColDef().filter);
  public readonly sortEnabled = computed(() => this.params().enableSorting ?? true);
  public readonly sort = computed<SortDirection>(
    () => this.params().context.grid.filters.sortModel()[this.params().column.getColId()] ?? null
  );
  public readonly filterActive = computed(() => {
    this.params().context.grid.filters.changedAt();
    return this.params().column.isFilterActive();
  });

  showFilter(div: HTMLDivElement) {
    if (div) {
      const params = this.params();
      if (params.showFilter) {
        params.showFilter(div);
      } else {
        params.showColumnMenu(div);
      }
    }
  }
  toggleSort() {
    if (!this.sortEnabled()) {
      return;
    }
    const params = this.params();
    const order = params.column.isSortAscending() ? 'desc' : 'asc';
    params.setSort(order);

    params.context.grid.filters.applyFilterModel({}, FilterModelSource.storage);
  }

  refresh(params: IHeaderParams) {
    return false;
  }
}
